module.exports={
	"Form": "ObservationTagEditManifest",
	"Scope": "ObservationTag-Edit",
	"Descriptors":
	{
		"ObservationTagDetails.IDObservationTag":
		{
			"Name": "ID",
			"Hash": "ObsTagEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.GUIDObservationTag":
		{
			"Name": "GUID",
			"Hash": "ObsTagEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagEdit-Tag",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagEdit-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.Description":
		{
			"Name": "Description",
			"Hash": "ObsTagEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 6,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.Global":
		{
			"Name": "Global",
			"Hash": "ObsTagEdit-Global",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ObsTagEdit-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		},
		"ObservationTagDetails.IDBidItem":
		{
			"Name": "Bid Item ID",
			"Hash": "ObsTagEdit-IDBidItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		},
		"ObservationTagDetails.IDLineItem":
		{
			"Name": "Line Item ID",
			"Hash": "ObsTagEdit-IDLineItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsTagEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsTagEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsTagEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsTagEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Associations",
			"Hash": "ObsTagEditAssociations",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Associations",
					"Hash": "ObsTagEditAssociations",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
